<template>
    <div class="listing_detail_wrap">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs gray-bg" role="tablist">
            <li role="presentation" v-if="inspeccionType.tipo_inspeccion != 'basica'">
                <a
                    class="active"
                    href="#chequeo"
                    aria-controls="chequeo"
                    role="tab"
                    data-toggle="tab"
                    >Inspección
                </a>
            </li>
            <li role="presentation">
                <a
                    href="#ficha-tecnica"
                    aria-controls="ficha-tecnica"
                    role="tab"
                    data-toggle="tab"
                    >Características</a
                >
            </li>
            <li role="presentation" v-if="accesoriosType.length != 0">
                <a
                    href="#accesorios"
                    aria-controls="accesorios"
                    role="tab"
                    data-toggle="tab"
                    >Accesorios</a
                >
            </li>
            <li role="presentation">
                <a
                    href="#costo-total "
                    aria-controls="costo-total"
                    role="tab"
                    data-toggle="tab"
                    >Costo Total
                </a>
            </li>
        </ul>
        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active" id="chequeo" v-if="inspeccionType.tipo_inspeccion != 'basica'">
                <chequeo />
            </div>
            <div role="tabpanel" :class="inspeccionType.tipo_inspeccion !== 'basica' ? 'tab-pane' : 'tab-pane active'" id="ficha-tecnica">
                <fichaTecnica />
            </div>
            <div role="tabpanel" class="tab-pane" id="accesorios">
                <listaAccesorios />
            </div>
            <div role="tabpanel" class="tab-pane" id="costo-total">
                <costoTotal />
            </div>
        </div>
    </div>
</template>

<script>
import fichaTecnica from "./fichaTecnica";
import listaAccesorios from "./accesorios";
import costoTotal from "./costo";
import chequeo from "./chequeo";
export default {
    components: {
        fichaTecnica,
        listaAccesorios,
        costoTotal,
        chequeo
    },
    computed: {
        inspeccionType() {
            return this.$store.state.fichaTecnica.vehiculo.tabs.inspeccion;
        },
        accesoriosType() {
            return this.$store.state.fichaTecnica.vehiculo.tabs.accesorios;
        },
    }
};
</script>

<style lang="scss">
.listing_detail_wrap .nav-tabs > li a {
    padding: 10px 30px;
}
.listing_detail_wrap .nav-tabs > li a.active {
    color: #fff;
    background: #000000;
}
</style>
